export default __webpack_public_path__ + "static/media/arlington_hero.b8eeb830.jpg";